<!-- eslint-disable @angular-eslint/template/no-call-expression -->
@if (!product$$().status?.selectedColor?.uniqueSize) {
    <div class="row {{ classSizeWrap() }}">
        <div class="col-xs-12">
            <div class="text-l">
                <div class="pt-0 pb-0 align-items-center content-sp-between">
                    <div class="align-middle d-inline">
                        <button
                            type="button"
                            id="btnSizeGuide"
                            class="is-flex align-top btn btn-clear ttu btn-tertiary"
                            (click)="openSizeGuide($event)"
                            elementObserverDirective
                            [observeType]="'analyticsClick'"
                            [observedData]="{ clickId: ANALYTICS_CLICK_SOURCE_ID_SIZE_GUIDE, product: product$$() }"
                        >
                            <span class="text-l">
                                {{ 'dev.product.detail.seeMeasurements' | translate }}
                            </span>
                        </button>
                    </div>
                    <div>
                        @if (sastreActivated$$() && isOpenForSale$$()) {
                            <div>
                                <sastre-button [product]="product$$()"></sastre-button>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
}
